import React, { useState, useEffect, useCallback } from 'react';
import api from '../../services/api';
import useAuth from '../../hooks/useAuth';
import { Link } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import Autocomplete from '../HtmlElements/Autocomplete';
import { useNavigate } from 'react-router-dom';
import ConfirmDialog from '../HtmlElements/ConfirmDialog';
import './Accounts.css';
import ScreenLoader from '../HtmlElements/ScreenLoader'
import Alert from '../HtmlElements/Alert';
import { useUser } from '../../context/UserContext';
import AsyncSelect from 'react-select/async';
import ActionDropdown from '../HtmlElements/ActionDropdown';
import SubmitActionButton from '../HtmlElements/SubmitActionButton';
import ActionCheckbox from '../HtmlElements/ActionCheckbox';
import { useDispatch } from 'react-redux';
import { resetAllAccDepen } from '../../store/features/actions/commonActions';
import AccountPlanTdComp from './AccountPlanTdComp';
import { getDemoRequestsCreateAccount } from '../../services/accIqService';

const Accounts = () => {
  useAuth(); // Ensure the user is authenticated

  const { user, handleLogout } = useUser();
  const current_role_key = user?.role_key;

  const [successMessage, setSuccessMessage] = useState('');
  const [accounts, setAccounts] = useState([]);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(10);
  const [sortField, setSortField] = useState('client_name');
  const [sortOrder, setSortOrder] = useState('asc');
  const [filter, setFilter] = useState({ client_name: '', account_name: '',is_deleted:0, is_active: ''});
  const [showAddAccModal, setShowModal] = useState(false);

  const [newClientName, setNewClientName] = useState('');
  const [newClientCode, setNewClientCode] = useState('');
  const [newAccountName, setNewAccountName] = useState('');
  const [newAccountCode, setNewAccountCode] = useState('');

  const [showConfirm, setShowConfirm] = useState(false);
  const [companyToDelete, setCompanyToDelete] = useState(null);

  const [addApiError, setApiError] = useState('');
  const [loader, setLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [showArchive, setShowArchive] = useState(0);
  const [showDemo, setShowDemo] = useState(0);
  const [formData, setFormData] = useState({});

  const [inputValue, setValue] = useState('');
  const [selectedValue, setSelectedValue] = useState(null);
  const [action, setAction] = useState({action: ''});
  const [checkedItems, setCheckedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [updateDataStatus, setupdateDataStatus] = useState(false);
  const [demoRequests, setDemoRequests] = useState([]);
  const [selectedDemoRequest, setSelectedDemoRequest] = useState("");
  const [enteredTicker, setEnteredTicker] = useState("");
  const [customError, setCustomError] = useState({});

  const handleAutoCompleteChange = (e) => {
    const { name, value, code } = e.target;
    if(name === "client_name"){
      setNewClientName(value)
      setNewClientCode(code)
      setCustomError((prevErrors) => ({
        ...prevErrors,
        newClientName: "",
      }));
    }else if(name === "account_name"){
      setNewAccountName(value)
      setNewAccountCode(code)
    }


  }

  useEffect(() => {
    const fetchDemoRequestList = async () => {
      const demo_requests = await getDemoRequestsCreateAccount();
      // console.log("Demo Requests: "+JSON.stringify(demo_requests));
      setDemoRequests(demo_requests);
    }
    fetchDemoRequestList();
  }, []);

  const fetchAccounts = useCallback(async () => {
    setLoader(true);

    // Dummy Call for sync specific account
    // const response = await api.post('/accounts/re_add_accounts', {});
    // return false

    try {
      if(filter.is_active === ""){
        delete(filter.is_active)
      }
      if(filter.status === ""){
        delete(filter.status)
      }
      const response = await api.get('/accounts/get_accounts', {
        params: {          
          page: currentPage,
          limit: perPage,
          sort_by: sortField,
          order: sortOrder,
          ...filter,
        },
      });
      // console.log(response.data.result.list);
      setAccounts(response.data.result.list);
      setTotalPages(Math.ceil(response.data.result.total / perPage));
    } catch (err) {
      setError(err.message || 'Failed to fetch Accounts');
    }
    setLoader(false);
  }, [currentPage, perPage, sortField, sortOrder, filter, updateDataStatus]);
  const dispatch = useDispatch();

  useEffect(() => {
      dispatch(resetAllAccDepen())
    let successMessage = sessionStorage.getItem('successMessage');
    if (successMessage) {
      setSuccessMessage(successMessage);
      sessionStorage.removeItem('successMessage'); // Clear the message
    }
    fetchAccounts();
  }, [fetchAccounts]);

  useEffect(() => {
    if(checkedItems.length > 0 && checkedItems.length === accounts.length){
      setSelectAll(true);
    }else{
      setSelectAll(false);
    }
  }, [checkedItems])

  /*const getselectedAMObjects = (AMIds) => {
    return accounts.filter(amuser => AMIds.includes(amuser.id));
  };

  const selectedAMObjects = getselectedAMObjects(formData.accountmanager);*/

  const handleSort = (field) => {
    const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortField(field);
    setSortOrder(order);
  };

  /*const handleFilterChange = (e) => {
    setCurrentPage(1);
    setFilter({ ...filter, [e.target.name]: e.target.value });
  };*/
  const showArchived = (e) => {
    setCurrentPage(1);
    //alert(e.target.value);   
      //let temp = document.getElementById("archived");*/
    let temp = e.target;
    if (temp.value == 0) {
      //temp.value = 1;
      e.target.value = 1;
      setFilter({ ...filter, [e.target.name]: e.target.value });
    } else {
      //temp.value = 0;
      e.target.value = 0;
      setFilter({ ...filter, [e.target.name]: e.target.value });
    }
    setShowArchive(temp.value);
  };

  const showForDemo = (e) => {
    setCurrentPage(1);
    //alert(e.target.value);   
      //let temp = document.getElementById("archived");*/
    let temp = e.target;
    if (temp.value == 0) {
      //temp.value = 1;
      e.target.value = 1;
      setFilter({ ...filter, [e.target.name]: e.target.value });
    } else {
      //temp.value = 0;
      e.target.value = "";
      setFilter({ ...filter, [e.target.name]: e.target.value });
    }
    setShowDemo(temp.value);
  };

  const handleFilterChange = (e) => {
    setCurrentPage(1);
    setFilter({ ...filter, [e.target.name]: e.target.value });
  };

  const handleActionChange = (e) => {
    setAction({ ...action, [e.target.name]: e.target.value });
  };

  const modalAddAccount = () => {
    setShowModal(true);
  };

  const handleAddAccount = async (e) => {
    e.preventDefault();

    const newError = {};
    let isValid = true;

    if (!formData?.accounts?.length) {
      newError.accounts = "Account required.";
      isValid = false;
    }

    if (newClientName == "") {
      newError.newClientName = "Client name required";
      isValid = false;
    }

    if (enteredTicker == "") {
      newError.enteredTicker = "Account ticker required.";
      isValid = false;
    }

    if (selectedDemoRequest == "") {
      newError.newDemoRequest = "Demo request required.";
      isValid = false;
    }

    setCustomError(newError);
    if (!isValid) return;

    const formattedData = {
      newaccountstoadd: formData.accounts
    }
    // console.log(formattedData);
    setLoader(true);
    try {
      const response = await api.post('/accounts/add_account', {
        /*account_name: newAccountName,
        account_code: newAccountCode,*/
        accounts: formData.accounts,
        client_name: newClientName?.trim(),
        client_code: newClientCode?.trim(),
        demo_request_id: selectedDemoRequest,
        ticker: enteredTicker
      });

      if (response.data.status === 201 || response.data.status === 200) {
        setSuccessMessage('Account added successfully');
        setTimeout(() => {
          setSuccessMessage('');
        }, 2000);

        fetchAccounts();
        handleClose();
      }else{
        setApiError(response.data.result.message || 'An error occurred while saving the company.');
      }

    } catch (err) {
      setError(err.message || 'Failed to add account');
    }
    setLoader(false);
  };

  const handleClose = () => {
    setShowModal(false);
    setNewClientName('');
    setNewClientCode('');
    setNewAccountName('');
    setNewAccountCode('');
  };

  const handleDelete = async () => {
    setLoader(true);
    try {
      await api.delete(`/accounts/delete_account/${companyToDelete}`);
      hideDeleteConfirm();
      setSuccessMessage('Account deleted successfully..!');
      setAccounts((prevCompanies) => prevCompanies.filter(company => company.id !== companyToDelete));
    } catch (error) {
      console.error('Error deleting company:', error);
    }
    setLoader(false);
  };

  const showDeleteConfirm = (companyId) => {
    setCompanyToDelete(companyId);
    setShowConfirm(true);
  };

  const hideDeleteConfirm = () => {
    setShowConfirm(false);
    setCompanyToDelete(null);
  };
  const handleFirstPage = () => {
    setCurrentPage(1);
    setSelectAll(false);
    setCheckedItems([]);
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages);
    setSelectAll(false);
    setCheckedItems([]);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
    setSelectAll(false);
    setCheckedItems([]);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    setSelectAll(false);
    setCheckedItems([]);
  };

  const handlePageChange = (pageNumber) => {
     setCurrentPage(pageNumber);
     setSelectAll(false);
     setCheckedItems([]);
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };
  
  if(current_role_key == undefined){
    return <></>
  }
  if(current_role_key === 'CLIENT'){
    // navigate('/user_profile/profile');
    window.location.replace('/user_profile/profile');
  }

  const handleInputChange = value => {
    setValue(value);
    setCustomError((prevErrors) => ({
      ...prevErrors,
      accounts: "",
    }));
  }

  const handleChange = value => {
    setSelectedValue(value);
    const newAccountslist = value.map((newaccountsObj) => {
      return {
        account_name: newaccountsObj.name,
        account_code: newaccountsObj.code
      };
    });

    setFormData({
      ...formData,
      accounts: newAccountslist
    });
    // console.log("SELECTED VALUES: "+JSON.stringify(formData))
  }

  const handleTickerChange = (e) => {
    setEnteredTicker(e.target.value)
    setCustomError((prevErrors) => ({
      ...prevErrors,
      ticker: "",
    }));
  }

  const handleDemoRequestChange = (e) => {
    setSelectedDemoRequest(e.target.value)
    setCustomError((prevErrors) => ({
      ...prevErrors,
      newDemoRequest: "",
    }));
  }

  const getAccounts = (text) => {
    return api.get('/company_profiles/suggest_company_name/?query='+text).then(result => {
      const res = result.data.result.list;
      return res;
    });
  }

  return (
    <div className="account_wrapper">
      { loader === true && (<ScreenLoader />) }
      <div className="container-fluid mt-3 p-4">

        {successMessage && <Alert type="success" message={successMessage} />}
        {error && <Alert type="danger" message={error} />}        
        
        <div className='row'>
            <div className='col-md-9'>
              <h4 className="blue add_user_heading">Accounts List</h4>
            </div>
            <div className="col-md-3 align-right pb-3">
              <Link className="add_account_btn" to="#" onClick={modalAddAccount}>
              <i className="fa fa-plus" aria-hidden="true"></i> Add Account
              </Link>
            </div>
        </div>

        <div className="row mb-3 mt-4">
          <div className='col-md-9'>
            <div className='left_filter'>
            <div className='admin_filter_head'>

              <h5 className=''>Filter</h5>
              </div>
            <div className='row'>
          <div className="col">
            <input
              type="text"
              className="form-control custom_form_control"
              placeholder="Filter by Client Name"
              autoComplete="Off"
              name="client_name"
              value={filter.client_name}
              onChange={handleFilterChange}/>
          </div>
          <div className="col">
            <input
              type="text"
              className="form-control custom_form_control"
              placeholder="Filter by Account Name"
              autoComplete="Off"
              name="account_name"
              value={filter.account_name}
              onChange={handleFilterChange}/>
          </div>
          <div className="col search_filter_user">
            <select
              className="custom_form_control w-100 form-control"
              as="select"
              id="selectfilter"
              name="is_active"
              value={filter.is_active}
              onChange={handleFilterChange}
            >             
              <option key="" value="">
                Select Filter
              </option>
              <option key="0" value="0">
                Inactive
              </option>
              <option key="1" value="1">
                Active
              </option>              
            </select>
          </div>

          <div className="col search_filter_user ">
            <select
              className="custom_form_control w-100"
              as="select"
              id="selectStatusFilter"
              name="status"
              value={filter.status}
              onChange={handleFilterChange}
            >
              <option key="" value="">
                Select Filter
              </option>
              <option key="0" value="0">
                Pending
              </option>
              <option key="1" value="1">
                Completed
              </option>
            </select>
          </div>
          <div className="col show_archived d-block" style={{ marginTop: '-8px' }}>
            <div className='arch'>
            <input
              id="archived"
              type="checkbox"
              className="form-check-input custom_input_type"
              name="is_deleted"
              value={filter.is_deleted}
              onClick={showArchived}
            /> <label className="form-check-label custom_lable_type" htmlFor="archived">Archived</label>

            </div>

            <div className='arch'>
            <input
              id="for_demo"
              type="checkbox"
              className="form-check-input custom_input_type"
              name="is_avail_for_demo"
              value={filter.is_avail_for_demo}
              onClick={showForDemo}
            /> <label className="form-check-label custom_lable_type" htmlFor="for_demo">For Demo</label>

            </div>

          </div>
          </div>
          </div>
          </div>
          <div className='col-md-3'>
          <div className='right_action'>
            <div className='admin_filter_head'>
            <h5 className=''>Actions</h5>

            </div>

            <div className='row'>
        

          <ActionDropdown page="accounts" action={action.action} setAction={setAction} />
          <SubmitActionButton
            page = 'accounts'
            checkedItems = {checkedItems}
            setCheckedItems = {setCheckedItems}
            action = {action.action}
            currentPage = {currentPage}
            setSelectAll = {setSelectAll}
            setupdateDataStatus = {setupdateDataStatus}
            setSuccessMessage = {setSuccessMessage}
            setCurrentPage = {setCurrentPage}
            setLoader = {setLoader}
            setAction = {setAction}
          />

        </div>
        </div>
        </div>
        </div>

        <div className='table-responsive'>
        <table className="table table-striped font14 table-bordered ">
          <thead>
            <tr className="cursor_p">
              <th>
                {/* <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                /> */}
                <ActionCheckbox
                  page = 'accounts'
                  accounts = {accounts}
                  checkedItems = {checkedItems}
                  setCheckedItems = {setCheckedItems}
                  selectAll = {selectAll}
                  setSelectAll = {setSelectAll}
                />
              </th>
              <th onClick={() => handleSort('client_name')}>
                Client Name {sortField === 'client_name' && (sortOrder === 'asc' ? '▲' : '▼')}
              </th>
              <th onClick={() => handleSort('account_name')}>
                Account Name {sortField === 'account_name' && (sortOrder === 'asc' ? '▲' : '▼')}
              </th>
              <th onClick={() => handleSort('account_name')}>
                Added By {sortField === 'account_name' && (sortOrder === 'asc' ? '▲' : '▼')}
              </th>
              <th onClick={() => handleSort('is_active')}>
                Is Active {sortField === 'is_active' && (sortOrder === 'asc' ? '▲' : '▼')}
              </th>
              <th onClick={() => handleSort('status')}>
                Status {sortField === 'status' && (sortOrder === 'asc' ? '▲' : '▼')}
              </th>
              { showArchive != 1 && (<th>Action</th>)}
              <th>Account Plan</th>
            </tr>
          </thead>
          <tbody>
            {accounts.map((account, index) => {
              return (<tr key={index}>
                <td>
                  {/* <input
                    type="checkbox"
                    checked={checkedItems.includes(account.id)}
                    onChange={() => handleCheckboxChange(account.id)}
                  /> */}
                  <ActionCheckbox
                    page = 'accounts'
                    checkedItems = {checkedItems}
                    setCheckedItems = {setCheckedItems}
                    related_id = {account.id}
                  />
                </td>
                <td>
                    {account.client_name}

                    {account?.is_avail_for_demo == 1 && <span className='demo_image_ ml-1' title='Available  For Demo'>
                    <i className="fa fa-laptop" aria-hidden="true"></i>

                    </span>
                    }
                </td>
                <td>
                    <Link to={'/account_details/'+account.id+'/'+account.account_name+'/'+account.client_name}>
                      {account.account_name}
                    </Link>
                </td>
                <td>{account.created_by_firstname} {account.created_by_lastname}</td>
                <td>{account.is_active === 1 ? 'Yes' : 'No'}</td>
                <td>{account.status === 1 ? 'Completed' : 'Pending'}</td>
                { showArchive != 1 && (<td>
                  {/* <Link to={`/accounts/edit_user/${account.id}`} className="edit_right_margin cursor_p">
                    <span><i className="fa fa-edit blue"></i></span>
                  </Link> */}
                  <span
                    onClick={() => showDeleteConfirm(account.id)}
                    className="cursor_p">
                    <i className="fa fa-trash"></i>
                    </span>
                </td>)}

                <td><AccountPlanTdComp key={account?.client_code+"_"+account?.account_code} clientCode={account?.client_code} accountCode={account?.account_code} accountName={account?.account_name} clientName={account?.client_name} filePath={account?.file_path} refreshAPI={fetchAccounts}/></td>
              </tr>)
            })}
          </tbody>
        </table>
        </div>
        <nav>
          <ul className="pagination">
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <button onClick={handleFirstPage} className="page-link">First</button>
            </li>
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <button onClick={handlePrevPage} className="page-link">Prev</button>
            </li>
            {getPageNumbers().map((pageNumber) => (
              <li key={pageNumber} className={`page-item ${pageNumber === currentPage ? 'active' : ''}`}>
                <button onClick={() => handlePageChange(pageNumber)} className="page-link">
                  {pageNumber}
                </button>
              </li>
            ))}
            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
              <button onClick={handleNextPage} className="page-link">Next</button>
            </li>
            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
              <button onClick={handleLastPage} className="page-link">Last</button>
            </li>
          </ul>
        </nav>
      </div>

      <Modal show={showAddAccModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Account</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
          {addApiError && <div className="alert alert-danger">{addApiError}</div>}
          </div>
            <div className="row mb-3">
                <div className="col-md-12">
                    <label htmlFor="labelCompanyName" className="form-label custom_label">Client Name <span className='red'>*</span></label>
                    <Autocomplete
                      name="client_name"
                      key="suggest_client_name"
                      value={newClientName}
                      onChange={handleAutoCompleteChange}
                      placeholder="Client Name"
                      element_field_key="client_name"
                      apiUrl="/company_profiles/suggest_client_name"
                      labelKey="name"
                      valueKey="code"/>
                      {customError.newClientName && (
                        <p className="text-danger">{customError.newClientName}</p>
                      )}
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                  <label htmlFor="labelAccountName" className="form-label custom_label">Account Name <span className='red'>*</span></label>
                  <AsyncSelect
                    name="accounts"
                    getOptionValue={e => e.code}
                    getOptionLabel={e => e.name}
                    loadOptions={getAccounts}
                    isMulti={true}
                    onInputChange={handleInputChange}
                    onChange={handleChange}
                    displayValue="account_name"
                    placeholder="Select Accounts"
                    disabled>
                  </AsyncSelect>
                  {customError.accounts && (
                    <p className="text-danger">{customError.accounts}</p>
                  )}
                </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-12">
                <label htmlFor='ticker' className="form-label custom_label">Ticker <span className='red'>*</span></label>
                <input
                  type='text'
                  name="ticker"
                  className="form-control"
                  value={enteredTicker}
                  onChange={(e) => handleTickerChange(e)}
                  style={{fontSize: '14px',
                    color: '#6c757d'
                  }}
                />
                {customError.enteredTicker && (
                  <p className="text-danger">{customError.enteredTicker}</p>
                )}
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-12">
                <label htmlFor='newDemoRequest' className="form-label custom_label">Demo Request <span className='red'>*</span></label>
                <select
                  name="newDemoRequest"
                  className="form-control"
                  value={selectedDemoRequest}
                  onChange={(e) => handleDemoRequestChange(e)}
                  style={{fontSize: '14px',
                    color: '#6c757d'
                  }}
                >
                  <option value="">Select Request</option>
                  {demoRequests.map((demo) => (
                    <option key={demo?._id} value={demo?._id}>
                      {demo?.seller_account_name+" - "+demo?.buyer_account_name+" - "+demo?.name}
                    </option>
                  ))}
                </select>
                {customError.newDemoRequest && (
                  <p className="text-danger">{customError.newDemoRequest}</p>
                )}
              </div>
            </div>

        </Modal.Body>
        <Modal.Footer>
          <Button disabled={loader} variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button disabled={loader} variant="danger" onClick={handleAddAccount}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <ConfirmDialog
        show={showConfirm}
        handleClose={hideDeleteConfirm}
        handleConfirm={handleDelete}
        title="Delete Account"
        message="Are you sure you want to delete this account?"/>        
    </div>
  );
};

export default Accounts;
